export const getBase64Img = async (
	path: Blob,
	setString: (url: string) => void
) => {
	let base64String = "";
	const reader = new FileReader();

	reader.onload = function () {
		base64String = reader.result as string;

		setString(base64String);
	};
	reader.readAsDataURL(path);
};
